module.exports = __webpack_public_path__ + "img/ColorizeOutlined.c015b400.svg";